'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId(id, pharmacyId) {
  this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_id = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_pharmacyId = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_id = id;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_pharmacyId = pharmacyId;
}
export { $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId as $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId };
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId() {
}
export { $h_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId as $h_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId };
$h_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype = $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype;
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1865986806, true);
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId)) {
    var x = this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_id;
    var x$2 = x$0.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_id;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_pharmacyId;
      var x$4 = x$0.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_pharmacyId;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.productPrefix__T = (function() {
  return "WithPharmacyId";
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_id;
  }
  if ((n === 1)) {
    return this.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId__f_pharmacyId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "pharmacyId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId)));
}
export { $isArrayOf_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId as $isArrayOf_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId };
var $d_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId, "app.data.types_drug$package$DrugRequestId$WithPharmacyId", ({
  Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId as $d_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId };
//# sourceMappingURL=app.data.types_drug$package$-Drug-Request-Id$-With-Pharmacy-Id.js.map
